// extracted by mini-css-extract-plugin
module.exports = {"selectedIcon":"style_selectedIcon__3z4lW","buttons":"style_buttons__NP57v"};